import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import '@/assets/styles/main.scss'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n, // Must inject i18n here
  render: h => h(App)
}).$mount('#app')
